import React from 'react';
type Props = {
  image: string;
  cover_images: string[];
  cover_videos: string[];
};

const CokitchenImageDetailCard = ({ image, cover_images, cover_videos }: Props) => {
  const hasImage = Boolean(image);
  const hasCoverImages = cover_images.length > 0;
  const hasCoverVideos = cover_videos.length > 0;

  if (!hasImage && !hasCoverImages && !hasCoverVideos) return null;

  return (
    <div className='py-1 border border-1 rounded-[10px] border-[#EDEDEE]'>
      {hasImage && (
        <>
          <p className='px-[24px] py-[18px] font-medium text-[#858585] text-sm'>Cokitchen image</p>
          <hr className='text-[#EDEDEE]' />
          <div className='mx-[24px] h-[220px] my-4 bg-[#F4F5F5] rounded-[10px] flex justify-center items-center'>
            <img className='h-full w-full object-cover' src={image} alt='event-image' />
          </div>
        </>
      )}

      {hasCoverImages && (
        <>
          <p className='px-[24px] py-[18px] font-medium text-[#858585] text-sm'>
            Cokitchen display images
          </p>
          <hr className='text-[#EDEDEE]' />
          <div className='p-6 flex gap-[20px] flex-wrap'>
            {cover_images.map((img, index) => (
              <div key={index} className='w-[160px] h-[160px]'>
                <img
                  src={img}
                  className='w-full h-full rounded-[10px] object-cover'
                  alt={`cover-img-${index}`}
                />
              </div>
            ))}
          </div>
        </>
      )}
      {hasCoverVideos && (
        <>
          <p className='px-[24px] py-[18px] font-medium text-[#858585] text-sm'>
            Cokitchen display videos
          </p>
          <hr className='text-[#EDEDEE]' />
          <div className='p-6 flex gap-[20px] flex-wrap'>
            {cover_videos.map((video, index) => (
              <div key={index} className='w-[160px] h-[160px]'>
                <video src={video} controls className='w-full h-full rounded-[10px] object-cover' />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default CokitchenImageDetailCard;
